import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navigation from "./components/sections/Navigation";
import Hero from "./components/sections/Hero";
import Problem from "./components/sections/Problem";
import TwoWays from "./components/sections/TwoWays";
import Work from "./components/sections/Work";
import HowIBuild from "./components/sections/HowIBuild";
import Founder from "./components/sections/Founder";
import Proof from "./components/sections/Proof";
import StartAProject from "./components/sections/StartAProject";
import Footer from "./components/sections/Footer";
import RobertPage from "./pages/RobertPage";
import RobertStatsPage from "./pages/RobertStatsPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import ServicePage from "./pages/ServicePage";
import PortfolioPage from "./pages/PortfolioPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import PricingPage from "./pages/PricingPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import CheckoutCancelPage from "./pages/CheckoutCancelPage";
import BillingPortalPage from "./pages/BillingPortalPage";
import AuditPage from "./pages/AuditPage";
import FrontOfficePage from "./pages/FrontOfficePage";
import NotFoundPage from "./pages/NotFoundPage";
import AuditQrPage from "./pages/AuditQrPage";
import HostingSetupPage from "./pages/HostingSetupPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import CaseStudyPage from "./pages/CaseStudyPage";
import NotesPage from "./pages/NotesPage";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "sonner";

const HomePage = () => (
  <div className="App" data-testid="app-root">
    <Navigation />
    <main>
      <Hero />
      <Problem />
      <TwoWays />
      <Work />
      <HowIBuild />
      <Founder />
      <Proof />
      <StartAProject />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:slug" element={<ProjectDetailPage />} />
        <Route path="/services/ai-chatbot-development" element={<Navigate to="/front-office" replace />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/audit/qr" element={<AuditQrPage />} />
        <Route path="/hosting/setup/:token" element={<HostingSetupPage />} />
        <Route path="/free-ai-audit" element={<Navigate to="/audit" replace />} />
        <Route path="/projects/the-pairing-mode" element={<Navigate to="/projects" replace />} />
        <Route path="/front-office" element={<FrontOfficePage />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />
        <Route path="/notes" element={<NotesPage />} />
        <Route path="/case-studies/:slug" element={<CaseStudyPage />} />
        <Route path="/front-desk" element={<Navigate to="/front-office" replace />} />
        <Route path="/ai-front-desk" element={<Navigate to="/front-office" replace />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
        <Route path="/billing" element={<BillingPortalPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/robert" element={<RobertPage />} />
        <Route path="/robert/stats" element={<RobertStatsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#0F2547",
            border: "1px solid rgba(40,200,240,0.35)",
            color: "#ffffff",
            fontFamily: "Roboto, sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
